// auto-generated by Typewriter template _models.tst from PortCall.Core.EndPoints\Api\User\ApiUser.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { PCUser, PCUserData, PCUserOptions } from 'data/models/PCUser';
import { UserRole, UserRoleData, UserRoleOptions } from 'data/models/UserRole';

// UserData is the class that User serializes to/from
export interface UserData {
    Id : number;
    Url : string | null;
	
    PCUser : PCUserData | null;
    Roles : UserRoleData[] | null;
	
    AccessFailedCount : number;
    Email : string | null;
    EmailConfirmed : boolean;
    LockoutEnabled : boolean;
    LockoutEndDateUtc : /* ISO8601 */ string | null;
    PasswordHash : string | null;
    PhoneNumber : string | null;
    PhoneNumberConfirmed : boolean;
    RolesUrlBase : string | null;
    SecurityStamp : string | null;
    TwoFactorEnabled : boolean;
    UserName : string | null;
}

// UserOptions is the class which may be passed to the User constructor to define optional initial data values
export interface UserOptions {
    Id : number;
    Url? : string | null;
	
    PCUser? : PCUserOptions | null;
    Roles? : UserRoleOptions[] | null;
	
    AccessFailedCount? : number;
    Email? : string | null;
    EmailConfirmed? : boolean;
    LockoutEnabled? : boolean;
    LockoutEndDateUtc? : /* ISO8601 */ string | null;
    PasswordHash? : string | null;
    PhoneNumber? : string | null;
    PhoneNumberConfirmed? : boolean;
    RolesUrlBase? : string | null;
    SecurityStamp? : string | null;
    TwoFactorEnabled? : boolean;
    UserName? : string | null;
}

export class User {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public PCUser : DataSignal<PCUser | null>;
    public Roles : SDataArray<UserRole>;
	
    public AccessFailedCount : DataSignal<number>;
    public Email : DataSignal<string | null>;
    public EmailConfirmed : DataSignal<boolean>;
    public LockoutEnabled : DataSignal<boolean>;
    public LockoutEndDateUtc : DataSignal<TZDate | null>;
    public PasswordHash : DataSignal<string | null>;
    public PhoneNumber : DataSignal<string | null>;
    public PhoneNumberConfirmed : DataSignal<boolean>;
    public RolesUrlBase : DataSignal<string | null>;
    public SecurityStamp : DataSignal<string | null>;
    public TwoFactorEnabled : DataSignal<boolean>;
    public UserName : DataSignal<string | null>;

    constructor();
    constructor(data : UserOptions);
    constructor(data: UserOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.PCUser = S.value<PCUser | null>(null);
        this.Roles = SArray<UserRole>([]);
	    
        this.AccessFailedCount = jsonableObservable(S.value<number>(data && data.AccessFailedCount !== undefined ? data.AccessFailedCount : 0));
        this.Email = jsonableObservable(S.value<string | null>(data && data.Email !== undefined ? data.Email : null));
        this.EmailConfirmed = jsonableObservable(S.value<boolean>(data && data.EmailConfirmed !== undefined ? data.EmailConfirmed : false));
        this.LockoutEnabled = jsonableObservable(S.value<boolean>(data && data.LockoutEnabled !== undefined ? data.LockoutEnabled : false));
        this.LockoutEndDateUtc = jsonableObservable(S.value<TZDate | null>(data && data.LockoutEndDateUtc !== undefined ? data.LockoutEndDateUtc === null ? null : new TZDate(data.LockoutEndDateUtc) : null, TZDate.nullableEq));
        this.PasswordHash = jsonableObservable(S.value<string | null>(data && data.PasswordHash !== undefined ? data.PasswordHash : null));
        this.PhoneNumber = jsonableObservable(S.value<string | null>(data && data.PhoneNumber !== undefined ? data.PhoneNumber : null));
        this.PhoneNumberConfirmed = jsonableObservable(S.value<boolean>(data && data.PhoneNumberConfirmed !== undefined ? data.PhoneNumberConfirmed : false));
        this.RolesUrlBase = jsonableObservable(S.value<string | null>(data && data.RolesUrlBase !== undefined ? data.RolesUrlBase : null));
        this.SecurityStamp = jsonableObservable(S.value<string | null>(data && data.SecurityStamp !== undefined ? data.SecurityStamp : null));
        this.TwoFactorEnabled = jsonableObservable(S.value<boolean>(data && data.TwoFactorEnabled !== undefined ? data.TwoFactorEnabled : false));
        this.UserName = jsonableObservable(S.value<string | null>(data && data.UserName !== undefined ? data.UserName : null));
    }

    static key(obj : User) {
        return obj.Id();
    }
    
    static dataKey(obj : UserOptions) {
        return obj.Id;
    }

    static update(obj : User, data : UserOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
	        
            if (data.AccessFailedCount !== undefined) obj.AccessFailedCount(data.AccessFailedCount);
            if (data.Email !== undefined) obj.Email(data.Email);
            if (data.EmailConfirmed !== undefined) obj.EmailConfirmed(data.EmailConfirmed);
            if (data.LockoutEnabled !== undefined) obj.LockoutEnabled(data.LockoutEnabled);
            if (data.LockoutEndDateUtc !== undefined) obj.LockoutEndDateUtc(data.LockoutEndDateUtc === null ? null : new TZDate(data.LockoutEndDateUtc));
            if (data.PasswordHash !== undefined) obj.PasswordHash(data.PasswordHash);
            if (data.PhoneNumber !== undefined) obj.PhoneNumber(data.PhoneNumber);
            if (data.PhoneNumberConfirmed !== undefined) obj.PhoneNumberConfirmed(data.PhoneNumberConfirmed);
            if (data.RolesUrlBase !== undefined) obj.RolesUrlBase(data.RolesUrlBase);
            if (data.SecurityStamp !== undefined) obj.SecurityStamp(data.SecurityStamp);
            if (data.TwoFactorEnabled !== undefined) obj.TwoFactorEnabled(data.TwoFactorEnabled);
            if (data.UserName !== undefined) obj.UserName(data.UserName);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/User.ts